export const doesPublicFileExistAsync = (url: string, timeout = 0): Promise<boolean> => {
  return new Promise((resolve) => {
    try {
      const xmlHttp = new XMLHttpRequest();

      xmlHttp.ontimeout = (_) => {
        return resolve(false);
      };
      xmlHttp.onerror = (_) => {
        return resolve(false);
      };

      xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === 4) {
          resolve(xmlHttp.status === 200);
        }
      };

      xmlHttp.open('GET', url, true);
      xmlHttp.timeout = timeout;
      xmlHttp.send(null);
    } catch (err) {
      resolve(false);
    }
  });
};

export const isSvgFile = (file: File): boolean => {
  return file.type === 'image/svg+xml' || file.name.toLowerCase().endsWith('.svg');
};

export const isHeicImageFile = (file: File): boolean => {
  return file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic');
};

/**
 * Mirrors PHP make_filename_safe: remove leading hyphens and any disallowed characters
 * Allowed: alphanumeric, underscore, space, parentheses, hyphen. When hyphenate=true, replace removed chars with '-'.
 */
export function makeFilenameSafe(name: string, defaultValue: string, hyphenate = false): string {
  const replacement = hyphenate ? '-' : '';
  const safe = name.replace(/^-+|[^\w_ ()-]+/g, replacement).trim();
  return safe !== '' ? safe : defaultValue;
}
